import { render } from "./Views.vue?vue&type=template&id=71013eea"
import script from "./Views.vue?vue&type=script&lang=js"
export * from "./Views.vue?vue&type=script&lang=js"

import "./Views.vue?vue&type=style&index=0&id=71013eea&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "71013eea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71013eea', script)) {
    api.reload('71013eea', script)
  }
  
  module.hot.accept("./Views.vue?vue&type=template&id=71013eea", () => {
    api.rerender('71013eea', render)
  })

}

script.__file = "src/components/ms-puns-message/Views.vue"

export default script